(function($) {
    // Filter toggle for mobile/tablet
    $('.entity-find-page__filters__toggle').click(function() {
        $('.entity-find-page__filters').toggleClass('entity-find-page__filters--expanded');
        $('html, body').animate({
                scrollTop: $(".entity-find-page__filters__toggle").offset().top
            },
        200);
    });
})(jQuery);